import { Observable } from 'rxjs';
import {
  CHANGE_EXPIRED_PASSWORD,
  GENERATE_OTP,
  GET_OIDC_USER_MANAGER,
  LOGIN_BY_OTP,
  LOGIN_BY_PASSWORD,
  LOGIN_BY_PASSWORD_NO_INDEX,
  OIDC_SSO_LOGIN,
  RESET_PASSWORD,
  SEND_FORGOT_PASSWORD_MAIL,
  SSO_LOGIN,
} from '@/types/authentication.types';
import { LoginRequest } from '@/models/request/LoginRequest';
import { LoginResponse } from '@/models/response/LoginResponse';
import { $httpClient } from '@/services/httpClient';
import { SsoRequest } from '@/models/request/SsoRequest';
import { OidcSsoRequest } from '@/models/request/OidcSsoRequest';
import { OidcUserManager } from '@/models/OidcUserManager.model';

export default class AuthenticationService {
  private readonly baseApi: string;

  constructor() {
    this.baseApi = 'auth/';
  }

  public generateOtp(data: LoginRequest): Observable<LoginResponse> {
    return $httpClient.post<LoginResponse>(this.baseApi + GENERATE_OTP, data);
  }

  public loginByPassword(loginRequest: LoginRequest): Observable<LoginResponse> {
    return $httpClient.post<LoginResponse>(this.baseApi + LOGIN_BY_PASSWORD, loginRequest);
  }

  public loginByPasswordNoIndex(loginRequest: LoginRequest): Observable<LoginResponse> {
    return $httpClient.post<LoginResponse>(this.baseApi + LOGIN_BY_PASSWORD_NO_INDEX, loginRequest);
  }

  public changePassword(loginRequest: LoginRequest, token: string | null): Observable<LoginResponse> {
    return $httpClient.post<LoginResponse>('api/emp/lobby/' + CHANGE_EXPIRED_PASSWORD, loginRequest, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  }

  public loginByOtp(data: LoginRequest): Observable<LoginResponse> {
    return $httpClient.post<LoginResponse>(this.baseApi + LOGIN_BY_OTP, data);
  }

  public sendForgotPasswordMail(data: LoginRequest): Observable<LoginResponse> {
    return $httpClient.post<LoginResponse>(this.baseApi + SEND_FORGOT_PASSWORD_MAIL, data);
  }

  public resetPassword(data: LoginRequest): Observable<LoginResponse> {
    return $httpClient.post<LoginResponse>(this.baseApi + RESET_PASSWORD, data);
  }

  public ssoLogin(ssoRequest: SsoRequest): Observable<LoginResponse> {
    return $httpClient.post<LoginResponse>(this.baseApi + SSO_LOGIN, {
      ssoToken: ssoRequest.ssoToken, recaptchaResponse: ssoRequest.recaptchaResponse,
    });
  }

  public oidcSsoLogin(ssoRequest: OidcSsoRequest): Observable<LoginResponse> {
    return $httpClient.post<LoginResponse>(this.baseApi + OIDC_SSO_LOGIN, {
      ssoAccessToken: ssoRequest.ssoAccessToken,
      ssoIdToken: ssoRequest.ssoIdToken,
      oidcId: ssoRequest.oidcId,
      recaptchaResponse: ssoRequest.recaptchaResponse,
    });
  }

  public getUserManager(oidcId: string): Observable<OidcUserManager> {
    return $httpClient.get<any>(this.baseApi + GET_OIDC_USER_MANAGER + '?oidcId=' + oidcId);
  }
}
